module.exports = __webpack_public_path__ + "static/img/SDC200应用场景-视觉识别.ad4dc9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type3-1/SDC200应用场景-视觉识别.png
// module id = HAXs
// module chunks = 0